import React from "react";
import { MaskedTextField } from "vault-react-components";

const InputMask = props => {
	const { input, meta, ...custom } = props;
	return (
		<MaskedTextField
			{...input}
			{...custom}
			touched={meta.touched}
			error={meta.error}
		/>
	);
};

export default InputMask;



// WEBPACK FOOTER //
// ./src/components/InputMask/InputMask.js